import { useQuery } from '@tanstack/react-query';
import { driverApi } from '../services/driverApi';
import { useHybridAuth } from './useHybridAuth';

/** One invoice (GET /invoices/:id), for the mobile shell's invoice screen. */
export const useInvoice = (invoiceId: string | undefined) => {
  const { getAccessTokenSilently, isAuthenticated } = useHybridAuth();
  return useQuery({
    queryKey: ['invoice', invoiceId],
    queryFn: async () => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      return driverApi.getInvoice(invoiceId!);
    },
    enabled: isAuthenticated && !!invoiceId,
  });
};
